import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';
import { GUITheme } from '../utils/baseConfig';
import config from '../utils/config';
import {
  getSessionStorage,
  loadFromStorageKeyPrefix,
  persistEntryPrefixed,
} from "./reduxStorageCommon";

interface UserSettingsState {
  guiTheme?: GUITheme;
}

const UserSettingsPrefix = "userSettings_";

const getStorage = () => {
  return getSessionStorage();
};

const loadFromStorage = (key: string) => {
  return loadFromStorageKeyPrefix(key, UserSettingsPrefix, getStorage());
};

const initialState: UserSettingsState = {
  guiTheme: loadFromStorage('guiTheme'),
};

export const userSettingsSlice = createSlice({
  name: 'userSettings',
  initialState,
  reducers: {
    setGUITheme: (state, action: PayloadAction<GUITheme | undefined>) => {
      state.guiTheme = action.payload;
    },
    clearUserSettings: (state) => {
      state.guiTheme = undefined;
    },
  }
});

export const {
  setGUITheme,
  clearUserSettings,
} = userSettingsSlice.actions;

// Selectors
// Selector that returns user override or config default
export const selectGUITheme = (state: RootState): GUITheme => {
  return state.userSettings.guiTheme ?? config.guiTheme;
};

export const selectGUIThemeOverride = (state: RootState): GUITheme | undefined => {
  return state.userSettings.guiTheme;
};

export const selectUserSettings = (state: RootState) => state.userSettings;

// Persistence setup
const persistEntry = (key: string, value: any) => {
  persistEntryPrefixed(UserSettingsPrefix, key, value, getSessionStorage());
};

export const setupUserSettingsPersistence = (store: any) => {
  store.subscribe(() => {
    const userSettingsState = store.getState().userSettings;

    persistEntry('guiTheme', userSettingsState.guiTheme);
    // Add persistence for future fields here
  });
};

export default userSettingsSlice.reducer;
